"use client"

import { COLOR } from '@/constant/color';
import styled from 'styled-components';

export const FootContainer = styled.div`
    width: 100%;
    min-height: 100px;
    background-color: #ffffff;
    color: ${COLOR.default};
    font-size: 10px;
    padding: 20px 30px;
    border-top: 1px solid #dddddd;
`;

export const FooterWrapper = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;

    & > img {
        @media (max-width: 768px) {
            /* display: none; */
        }
    }
`